import React from "react";
import { X } from "lucide-react";

export default function ChatDetailsPanel({
  open = false,
  onClose,
  title = "Chat details",
  subtitle = "History, summary, follow-up, and session tools.",
  children,
}) {
  return (
    <>
      <button
        type="button"
        className={`chat-details-backdrop${open ? " open" : ""}`}
        onClick={onClose}
        aria-label="Close details panel"
      />
      <aside
        id="chat-details-panel"
        className={`chat-details-panel${open ? " open" : ""}`}
        aria-hidden={!open}
      >
        <div className="chat-details-panel__header">
          <div>
            <div className="nia-subtitle">Session details</div>
            <h3>{title}</h3>
            <p>{subtitle}</p>
          </div>
          <button type="button" className="icon-btn chat-details-panel__close" onClick={onClose} aria-label="Close details">
            <X size={18} />
          </button>
        </div>
        <div className="chat-details-panel__body">{children}</div>
      </aside>
    </>
  );
}
